import React from "react";
import { motion } from "framer-motion";
import Mandala from "@/components/Mandala";
import { TID } from "@/constants/testIds";

const Loader = () => (
  <motion.div
    data-testid={TID.loader}
    initial={{ opacity: 1 }}
    exit={{ opacity: 0 }}
    transition={{ duration: 0.9, ease: "easeInOut" }}
    className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-[#0A0A0A]"
  >
    <div className="absolute inset-0 hero-radial opacity-70" />
    <div className="relative flex flex-col items-center">
      <motion.div
        data-testid={TID.loaderMandala}
        initial={{ opacity: 0, scale: 0.6 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 2.2, ease: [0.22, 1, 0.36, 1] }}
        className="pulse-glow"
      >
        <Mandala size={340} />
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 1.4, duration: 0.9 }}
        className="mt-10 text-center"
      >
        <div className="font-display text-4xl md:text-5xl tracking-[0.35em] text-white saffron-text-glow">
          KASHiX
        </div>
        <div className="mt-4 font-hindi text-xl md:text-2xl text-[#FF9933]">आस्था से अनंत तक</div>
        <div className="mt-2 text-xs md:text-sm tracking-[0.35em] uppercase text-white/60">
          Experience Where Devotion Becomes Power
        </div>
      </motion.div>
    </div>
  </motion.div>
);

export default Loader;
